module.exports = "##### Warning\n\nWe use this color for content or actions that require the user to take action or there might be consequences.\n"